export function IntakeSectionReducers(state = []): any {
  return [
    {
      name: 'APS INTAKE REPORT',
      key: 'aps_intake_report',
      json_key: 'intake_report',
      subSections: [
        {
          id: 'sectionA',
          name: 'A. Reporting Party Information',
          sections: ['main', 'aps_case_reporting_party']
        },
        {
          id: 'sectionB',
          name: 'B. Client Information',
          sections: ['main', 'victims']
        },
        {
          id: 'sectionC',
          name: 'C. Reported Vulnerability and Maltreatment',
          sections: ['main', 'referral_criteria']
        },
        {
          id: 'sectionD',
          name: 'D. Reported Type of Maltreatment',
          sections: ['main', 'perpetration_abuse_result']
        },
        {
          id: 'sectionE',
          name: 'E. Incident Information',
          sections: ['main', 'incident_addresses']
        },
        {
          id: 'sectionF',
          name: 'F. Alleged Perpetrator Information',
          sections: ['main', 'abusers']
        },
        {
          id: 'sectionG',
          name: 'G. Caregiver Information-Person responsible for the client\'s medical or financial care',
          sections: ['main', 'caregivers']
        },
        {
          id: 'sectionH',
          name: 'H. Witness or Other person believed to have knowledge of Maltreatment',
          sections: ['main', 'witnesses']
        },
        {
          id: 'sectionI',
          name: 'I. Receiving Agency Use Only',
          sections: ['main', 'receiving_agency']
        }
      ]
    },
    {
      name: 'CLIENT IDENTIFICATION & DEMOGRAPHICS',
      key: 'client_identification_demographics',
      json_key: 'intake_report',
      subSections: [
        {
          id: 'part1',
          name: 'Client Identification Demographics Part 1',
          sections: ['victims'],
          sub_section: ['client_main', 'client_footer']
        },
        {
          id: 'part2',
          name: 'Client Identification Demographics Part 2',
          sections: ['victims'],
          sub_section: ['demographics', 'client_footer']
        },
        {
          id: 'functional',
          name: 'Functional Abilities',
          sections: ['victims'],
          sub_section: ['functional_abilities', 'client_footer']
        },
        {
          id: 'additional_info',
          name: 'Additional Information'
        }
      ]
    },
    {
      name: 'INVESTIGATION',
      key: 'investigation',
      json_key: 'investigation',
      subSections: [
        {
          id: 'alleged_perpetrator_information',
          name: 'Alleged Perpetrator Information',
          sections: ['alleged_perpetrator_information', 'main']
        },
        {
          id: 'allegation_disposition',
          name: 'Allegation Disposition',
          sections: ['allegation_disposition', 'main']
        },
        {
          id: 'caregiver_information',
          name: 'Caregiver Information-Person responsible for the client\'s medical or financial care',
          sections: ['caregiver_information', 'main']
        },
        {
          id: 'witness_or_other_person',
          name: 'Witness or Other person believed to have knowledge of Maltreatment',
          sections: ['witness_or_other_person', 'main']
        },
        {
          id: 'services_or_referrals_made',
          name: 'Services/Referrals Made',
          sections: ['services_or_referrals_made', 'main']
        }
      ]
    },
    {
      key: 'assessments',
      name: 'ASSESSMENTS',
      json_key: 'assessments',
    },
    {
      name: 'CONTACTS',
      key: 'contacts',
      json_key: 'contacts',
      subSections: [
        {
          id: 'aps_contacts',
          name: 'APS Contacts',
          sections: ['aps_contacts']
        },
        {
          id: 'caregiver_relationship',
          name: 'Caregiver Relationship',
          sections: ['caregiver_relationship']
        }
      ]
    },
    {
      key: 'progress_notes',
      json_key: 'notes',
      name: 'PROGRESS NOTES'
    },
    {
      key: 'closing_summary',
      json_key: 'closing_summary',
      name: 'CLOSING SUMMARY'
    },
    {
      key: 'fcc',
      json_key: 'fcc',
      name: 'FOCUSED CARE COORDINATION'
    }
  ];
}
